import { buildInitialValues } from '../helpers'
import type { StandardWidgetSettings } from './standardWidgetSettingsSchema'

const DEFAULT_FONT_COLOR = 'ffffff'
const DEFAULT_FONT = 'Fira Sans'
const DEFAULT_FONT_SIZE = 16
const DEFAULT_FONT_WEIGHT = 700

const defaultValues = {
  darkMode: true,
  displayMode: 'default',
  style: 'standard',

  headlineFont: DEFAULT_FONT,
  headlineFontWeight: DEFAULT_FONT_WEIGHT,
  headlineFontSize: DEFAULT_FONT_SIZE,
  headlineFontColor: DEFAULT_FONT_COLOR,

  dataFont: DEFAULT_FONT,
  dataFontWeight: DEFAULT_FONT_WEIGHT,
  dataFontSize: DEFAULT_FONT_SIZE,
  dataFontColor: DEFAULT_FONT_COLOR,
} satisfies StandardWidgetSettings

const getDefaultValues = buildInitialValues(defaultValues)
export default getDefaultValues
